import { render, staticRenderFns } from "./EditLeadCustomerDialog.vue?vue&type=template&id=104c3dc8"
import script from "./EditLeadCustomerDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadCustomerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports